export const clues = [
  {
    slug: "community-property-fee-not-disclosed",
    title: "某小区物业收费多年未公示，业主希望看到完整明细",
    categorySlug: "rights",
    categoryName: "维权线索",
    summary:
      "多位业主反映，小区物业费与服务内容长期只在缴费单上体现，缺少年度收支公示。投稿人整理了近三年的缴费记录与业主群讨论。",
    region: "华东 · 某城区",
    date: "2026-08-28",
    status: "核实中",
    tags: ["物业", "收费公示", "社区治理"],
    views: 5842,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20beige%20residential%20building%20facade%20with%20balconies%20and%20green%20plants%2C%20soft%20afternoon%20light%2C%20muted%20editorial%20palette%2C%20documentary%20photography%2C%20no%20text&width=800&height=600&seq=clue-property-01&orientation=landscape",
    content: [
      "投稿人表示，自己所住小区自交付以来，物业费标准经过两次上调，但每次只有一张缴费通知，未见年度收支明细公示。业主群中已有不少人提出同样疑问。",
      "目前整理到的材料包括：2023 至 2025 三年的缴费凭证、两次调价通知的截图，以及业主代表与物业沟通的会议纪要片段。投稿人希望物业能以书面形式说明费用构成与公共收益去向。",
      "需要说明的是，上述内容为投稿人单方提供，平台尚未联系到物业方核实。若物业方有不同说法，欢迎通过联系入口补充说明，我们会并列呈现。",
    ],
  },
  {
    slug: "office-internal-notice-aircon-hours",
    title: "写字楼内部通知：下月起办公区空调开放时间将缩短",
    categorySlug: "internal",
    categoryName: "内部消息",
    summary:
      "投稿人提供了一份内部通知截图，内容涉及下月起办公区空调与照明的开放时段调整，以及部分区域的轮换使用安排。",
    region: "华南 · 某商务区",
    date: "2026-08-25",
    status: "已更新",
    tags: ["内部通知", "办公", "能耗"],
    views: 3120,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20modern%20office%20corridor%20with%20glass%20partitions%20and%20warm%20ceiling%20lights%2C%20muted%20ochre%20and%20charcoal%20tones%2C%20soft%20editorial%20photography%2C%20no%20text%20no%20people&width=800&height=600&seq=clue-office-01&orientation=landscape",
    content: [
      "通知提到，为控制能耗成本，自下月起写字楼公共办公区的空调开放时段将整体缩短，午间部分楼层改为轮换供冷，照明也调整为分区控制。",
      "投稿人补充，该调整目前处于通知阶段，尚未看到配套的工位安排说明。部分租户担心午后办公舒适度下降。",
      "平台已就该通知的时间与执行范围向投稿人做了二次确认，投稿人提供了后续的补充说明，故本条状态更新为“已更新”。",
    ],
  },
  {
    slug: "loose-manhole-cover-old-town-road",
    title: "老城区主干道井盖松动多日，夜间通行存在隐患",
    categorySlug: "daily",
    categoryName: "身边事",
    summary:
      "投稿人拍下了松动井盖的位置与夜间路面情况，称已多次反映但暂未看到明显处理痕迹，希望提醒附近居民注意。",
    region: "华中 · 老城区",
    date: "2026-08-22",
    status: "已归档",
    tags: ["道路安全", "市政", "身边事"],
    views: 2456,
    cover:
      "https://readdy.ai/api/search-image?query=rain%20slicked%20old%20town%20asphalt%20road%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20muted%20amber%20and%20deep%20ink%20tones%2C%20moody%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=clue-road-01&orientation=landscape",
    content: [
      "稿件描述，该路段一处井盖在车辆经过时会产生明显响动与位移，雨天积水后更难察觉。投稿人拍摄了白天与夜间两组照片用于对比。",
      "投稿人称，曾通过公开渠道反映过两次，期间有短暂的警示围挡，但随后又被移走。附近有夜跑与骑行的居民，存在一定安全顾虑。",
      "平台已联系投稿人核对具体位置信息并整理成一份可提交的说明。因后续进展超出投稿人可跟进范围，本条按流程归档保留。",
    ],
  },
  {
    slug: "online-course-hours-mismatch-refund",
    title: "线上课程被指宣传课时与实际不符，学员集中要求说明",
    categorySlug: "consumer",
    categoryName: "消费投诉",
    summary:
      "多名学员反映某线上课程的实际课时少于宣传页描述，投稿人整理了购买页面、课程目录与群内沟通记录。",
    region: "全国 · 线上",
    date: "2026-08-19",
    status: "核实中",
    tags: ["线上课程", "退费", "消费维权"],
    views: 4210,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20laptop%20and%20notebook%20on%20warm%20wooden%20desk%20with%20coffee%20cup%2C%20soft%20golden%20window%20light%2C%20muted%20editorial%20palette%2C%20no%20text%20on%20screen&width=800&height=600&seq=clue-course-01&orientation=landscape",
    content: [
      "投稿人表示，宣传页写明的总课时与课程目录中的实际章节数量存在差距，部分章节被标注为“敬请期待”，长期未更新。",
      "材料显示，学员曾在课程群内询问进度，得到的是“正在优化”的回复。目前已有若干名学员提出退费或补课诉求。",
      "上述内容以投稿人提供的截图为主，平台尚在向多位学员交叉核对，暂不对外发布具体机构名称，等待进一步核实。",
    ],
  },
  {
    slug: "community-canteen-price-change",
    title: "社区食堂外包后菜价调整，助餐补贴去向受关注",
    categorySlug: "public-events",
    categoryName: "公众事件",
    summary:
      "投稿人提到社区食堂更换运营方后菜单与价格同步调整，老年助餐补贴的使用方式也发生变化，居民希望了解规则细节。",
    region: "华北 · 某社区",
    date: "2026-08-15",
    status: "已更新",
    tags: ["社区食堂", "助餐补贴", "公共服务"],
    views: 3678,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20bright%20community%20dining%20hall%20interior%20with%20wooden%20tables%20and%20steam%20from%20food%20counter%2C%20soft%20daylight%2C%20muted%20editorial%20photography%2C%20no%20people%20no%20text&width=800&height=600&seq=clue-canteen-01&orientation=landscape",
    content: [
      "稿件反映，社区食堂由新的运营方接手后，菜单结构有所简化，单份价格上调，原有的套餐组合也做了改动。",
      "投稿人提到，老年助餐补贴的抵扣方式与之前不同，部分居民不清楚新规则如何计算，希望运营方与社区能给出书面说明。",
      "平台在收到稿件后联系到投稿人补充了价目表与前后对比信息，据此更新了本条内容的时间线与规则说明部分。",
    ],
  },
  {
    slug: "training-material-leak-assessment",
    title: "某行业内部培训材料外流，涉及岗位考核评分标准",
    categorySlug: "internal",
    categoryName: "内部消息",
    summary:
      "投稿人称收到一份内部培训与考核材料，其中包含岗位评分维度与权重设置，认为可能与对外承诺存在落差。",
    region: "华东 · 某行业",
    date: "2026-08-11",
    status: "核实中",
    tags: ["内部材料", "考核", "行业观察"],
    views: 2904,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20printed%20training%20manuals%20and%20highlighters%20on%20warm%20gray%20surface%2C%20muted%20crimson%20and%20ochre%20accents%2C%20soft%20side%20light%2C%20editorial%20still%20life%2C%20no%20legible%20text&width=800&height=600&seq=clue-training-01&orientation=landscape",
    content: [
      "投稿人提供了一份标注为内部使用的培训材料节选，其中列出了岗位考核的评分维度、权重与相应档位。",
      "投稿人认为，材料中的部分评价口径与此前对外说明的标准不完全一致，因此希望公开讨论。因涉及内部文件，稿件已做必要的信息打码。",
      "平台会优先核对文件的来源与版本，避免因版本差异造成误读。在核实完成前，本条仅呈现投稿人陈述，不代表平台结论。",
    ],
  },
  {
    slug: "prepaid-gym-closure-balance",
    title: "预付费健身门店暂停营业，会员卡余额处理暂无明确方案",
    categorySlug: "rights",
    categoryName: "维权线索",
    summary:
      "投稿人反映门店张贴暂停营业通知后，会员卡余额与私教课时的后续安排没有说明，多名会员在群内自发统计损失。",
    region: "西南 · 某商圈",
    date: "2026-08-07",
    status: "核实中",
    tags: ["预付费", "健身", "退款"],
    views: 5187,
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20empty%20gym%20interior%20with%20dumbbell%20rack%20and%20large%20windows%2C%20dusty%20warm%20light%20beams%2C%20muted%20sepia%20editorial%20photography%2C%20no%20people%20no%20text&width=800&height=600&seq=clue-gym-01&orientation=landscape",
    content: [
      "门店门口张贴的暂停营业通知未注明恢复时间与退款渠道。投稿人是两年期会员，卡内仍有较长时间未使用。",
      "会员群内已有人自发统计剩余金额与课时，并尝试通过多种渠道咨询，目前尚未得到统一答复。",
      "平台建议投稿人保留好合同、付款记录与沟通截图，这些材料对后续协商与维权都较为关键。本条仍在向多位会员交叉核实中。",
    ],
  },
  {
    slug: "old-town-renewal-compensation-draft",
    title: "旧城改造征收补偿方案征求意见稿中的几处疑点",
    categorySlug: "industry",
    categoryName: "行业观察",
    summary:
      "投稿人对一份征求意见稿中的评估口径与安置方式提出疑问，并对照周边项目整理了对比表，希望获得更清晰的解释。",
    region: "华中 · 旧城片区",
    date: "2026-08-03",
    status: "已归档",
    tags: ["征收", "补偿方案", "政策解读"],
    views: 4431,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20old%20dense%20city%20blocks%20rooftops%20seen%20from%20above%20at%20golden%20hour%2C%20warm%20terracotta%20and%20ochre%20tones%2C%20soft%20editorial%20aerial%20photography%2C%20no%20text&width=800&height=600&seq=clue-renewal-01&orientation=landscape",
    content: [
      "投稿人对照征求意见稿与周边已完成项目的公开信息，整理出一份口径对比，重点在评估时点与安置房折算方式两处。",
      "稿件提出的疑问主要面向流程本身，希望获得更通俗的解释，而非对具体金额的争议。",
      "因征求意见阶段已结束，本条按流程归档，同时保留投稿人整理的问题清单，供有相似疑问的读者参考。",
    ],
  },
];

export default clues;